<div class="app">
  <sa-header class="app__header"></sa-header>
  <main class="app__main">
    <router-outlet></router-outlet>
  </main>
</div>
